import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Bearer fallback (some browsers strict on cross-site cookies)
let bearer = null;
try {
  bearer = localStorage.getItem("access_token");
} catch (e) {}

export const setBearer = (token) => {
  bearer = token;
  try {
    if (token) localStorage.setItem("access_token", token);
    else localStorage.removeItem("access_token");
  } catch (e) {}
};

api.interceptors.request.use((config) => {
  if (bearer) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${bearer}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
